import React, { useState, useContext } from 'react'
import DisplayItem from '../displayItem/displayItem'
import styles from './uploadSummary.module.scss'
import Buttons from '../buttons/buttons'
import { Context } from '../context/provider'
import Loader from 'react-loader-spinner'
import { usePostError } from '../../utilities/usePostError'
import axios from 'axios'
import PropTypes from 'prop-types'

export default function UploadSummary({ formName, infoApi, nextLabel, formPath }) {
  const context = useContext(Context)
  const storage = typeof window !== 'undefined' ? window.sessionStorage : {}
  const [loader, setLoader] = useState(false)
  const handleError = usePostError()

  const { name, rollNumber, email, Fee, transactionId, formDocName, licenseName, phone, plateNumber } = storage;

  function formatNum(num) {
    return (Math.round(num * 100) / 100).toFixed(2);
  }

  const handleNext = async () => {
    setLoader(true)
    window.sessionStorage.setItem('mcn-form-path', formPath)

    const body = {
      key: process.env.GATSBY_SECRET,
      storage: {
        name,
        rollNumber,
        email,
        transactionId,
        filenames: JSON.stringify([licenseName, formDocName]),
        phone,
        plateNumber: plateNumber ?? '',
      }
    }

    if (parseInt(Fee) > 0) {
      body.storage['Fee'] = Fee
    }

    try {
      await axios.post(infoApi, { ...body })

      setLoader(false)
      context.setCurrent(2)

    } catch(e) {
      setLoader(false)
      handleError(e)
    }
  }
  
  const handleBack = () => {
    context.setCurrent(0)
  }

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2>Summary</h2>

        <DisplayItem {...{
          value: name,
          label: 'Name',
        }} />
        <DisplayItem {...{
          value: email,
          label: 'Email',
        }} />
        <DisplayItem {...{
          value: phone,
          label: 'Phone',
        }} />
        <DisplayItem {...{
          value: rollNumber,
          label: 'Citizen roll number',
        }} />
        {plateNumber && <DisplayItem {...{
          value: plateNumber,
          label: 'Tag',
        }} />}
        <DisplayItem {...{
          value: formDocName,
          label: formName,
        }} />
        <DisplayItem {...{
          value: licenseName,
          label: `Driver's license`,
        }} />

        {parseInt(Fee) > 0 && <>
          <hr className={styles.line}></hr>

          <div className={styles.fees}>
            <DisplayItem {...{
              value: storage.Fee,
              display: (val) => `$${formatNum(val)}`,
              label: 'Fee',
              total: true,
              showCheck: false,
            }} />
          </div>
        </>}

        <Buttons {...{
          handleBack,
          handleNext,
          backLabel: 'BACK',
          nextLabel: nextLabel ?? 'PAYMENT'
        }}>
          {loader && <div className={styles.loader}>
            <Loader type="ThreeDots" color="#2BAF49" height={20} width={80} />
          </div>}
        </Buttons>
      </div>
    </section>
  )
}

UploadSummary.propTypes = {
  formName: PropTypes.string,
  formPath: PropTypes.string,
  infoApi: PropTypes.string,
  nextLabel: PropTypes.string
}